import { fetchWrapper } from '../../common/ApiHelper';

const API_BASE_URL = process.env.REACT_APP_BACKEND_ROOT_PM;

const API_BASE_URL_DM = process.env.REACT_APP_BACKEND_ROOT_DM;

const API_BASE_URL_REPORT = process.env.REACT_APP_BACKEND_ROOT_REPORT;

// Program Management

export const getPrograms = () => fetchWrapper(`${API_BASE_URL}/api/programs/`);

export const createProgram = (programData) =>
  fetchWrapper(`${API_BASE_URL}/api/programs/`, {
    method: 'POST',
    body: JSON.stringify(programData),
  });

export const updateProgram = (id, programData) =>
  fetchWrapper(`${API_BASE_URL}/api/programs/`, {
    method: 'PUT',
    body: JSON.stringify(programData),
    params: { id },
  });

export const deleteProgram = (id) =>
  fetchWrapper(`${API_BASE_URL}/api/programs/`, {
    method: 'DELETE',
    params: { id },
  });

// Project Management

export const getProjectByProgram = (program_id) =>
  fetchWrapper(`${API_BASE_URL}/api/projects/`, {
    method: 'GET',
    params: { program_id },
  });

export const createProject = (projectData) =>
  fetchWrapper(`${API_BASE_URL}/api/projects/`, {
    method: 'POST',
    body: JSON.stringify(projectData),
  });

export const updateProject = (id, projectData) =>
  fetchWrapper(`${API_BASE_URL}/api/projects/`, {
    method: 'PUT',
    body: JSON.stringify(projectData),
    params: { id },
  });

export const deleteProject = (id) =>
  fetchWrapper(`${API_BASE_URL}/api/projects/`, {
    method: 'DELETE',
    params: { id },
  });

// Asset Management

export const getAssetByProject = (project_id) =>
  fetchWrapper(`${API_BASE_URL}/api/assets/`, {
    method: 'GET',
    params: { project_id },
  });

export const createAsset = (assetData) =>
  fetchWrapper(`${API_BASE_URL}/api/assets/`, {
    method: 'POST',
    body: JSON.stringify(assetData),
  });

export const updateAsset = (id, assetData) =>
  fetchWrapper(`${API_BASE_URL}/api/assets/`, {
    method: 'PUT',
    body: JSON.stringify(assetData),
    params: { id },
  });

export const deleteAsset = (id) =>
  fetchWrapper(`${API_BASE_URL}/api/assets/`, {
    method: 'DELETE',
    params: { id },
  });

// Report management
export const getReportUri = (project_id, asset_id, message_id) =>
  fetchWrapper(`${API_BASE_URL_REPORT}/api/report/make_report`, {
    method: 'POST',
    body: project_id
      ? JSON.stringify({ project_id })
      : asset_id
      ? JSON.stringify({ asset_id })
      : message_id
      ? JSON.stringify({ message_id })
      : {},
  });

//Generate Report
export const getGeneratedReport = (report_locations, conversation_id, message_id) =>{
  fetchWrapper(`${API_BASE_URL_REPORT}/api/report/generate_report`, {
    method: 'POST',
    body: JSON.stringify({
      report_locations,
      conversation_id,
      message_id,
    }),
  });
}

// Get GCP Blob
export const getBlobFromUri = (uri) =>
  fetchWrapper(
    `${API_BASE_URL_DM}/api/storage/get_gcs_blob`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        gcs_path: uri
      }),
    },
    true
  );


export const downloadReportFromGcs = (gcsPath) => {
  return fetchWrapper(
    `${API_BASE_URL_DM}/api/storage/get_gcs_blob`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        gcs_path: gcsPath
      }),
    },
    true // Return blob data
  );
};
